export default {
  categoryList: {
    padding: 0,
    marginBottom: 16,
    border: "1px solid #ededed",
    marginTop: 16
  }
};



// WEBPACK FOOTER //
// ./src/pages/Account/Groups/style.js